<style lang="less">
.ivu-tooltip-rel {
  display: inline-block;
}

.ivu-tooltip {
  display: inline-block;
}

// 确保 Tooltip 显示在最顶层
.ivu-tooltip-rel .ivu-tooltip {
  z-index: 9999 !important;
}

.ivu-tooltip-inner {
  z-index: 9999 !important;
  max-width: 400px !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  line-height: 1.6 !important;
}
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>待分配学生列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">

      <Form :label-width="100" :show-message="false" label-position="right">
        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="开课时间">
              <Row>
                <Date-picker v-model="dateRange" format="yyyy-MM-dd" :clearable="true" type="daterange"
                             placement="bottom-start" placeholder="选择日期" style="width: 100%"/>
              </Row>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程等级">
              <Select v-model.number="queryParam.bookMaterialLevelId" clearable @on-change="changeLevel">
                <Option value="0">未分级</Option>
                <Option v-for="item in bookMaterialLevelList" :key="item.id" :value="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="排序规则">
              <Select
                v-model.number="queryParam.sortRule"
                clearable
                @on-change="search"
              >
                <Option value="ASC">由少到多</Option>
                <Option value="DESC">由多到少</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="上课时间">
              <Select name="lessonWeek" multiple v-model="lessonWeek" clearable @on-change="selectWeek">
                <Option v-for="item in $constant.weekSelect" :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
        </Row>


        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="绑定课节数">
              <Input name="bindLessonNum" v-model.number="queryParam.bindLessonNum"/>
            </Form-item>
          </Col>


          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="剩余课节数">
              <Input name="lastLessonNum" v-model="queryParam.lastLessonNum"/>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课节数">
              <Select name="lessonNum" v-model="queryParam.lessonNum" clearable @on-change="search">
                <Option value="0">全部</Option>
                <Option value="1">前8节课学生</Option>
                <Option value="2">剩余10节课学生</Option>
              </Select>
            </Form-item>
          </Col>


          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="教材版本">
              <Select v-model="queryParam.materialVersionId" @on-change="loadLevelIds" placeholder="请选择" clearable>
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <Row>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="老师ID">
              <Input name="id" v-model="queryParam.tchId"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="老师名字">
              <Input
                placeholder="模糊"
                name="mobile"
                v-model="queryParam.tchName"
              ></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="是否绑定老师" prop="isTch">
              <Select v-model.number="queryParam.isTch" placeholder="全部" clearable @on-change="search">
                <Option value="1">已绑定老师</Option>
                <Option value="0">未绑定老师</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程顾问" prop="studyAdviserName">
              <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId"/>
            </Form-item>
          </Col>


        </Row>


        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生" :label-width="60">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="下周是否排课" prop="isNextWeekLessonOpened">
              <Select v-model.number="queryParam.isNextWeekLessonOpened" placeholder="全部" clearable
                      @on-change="search">
                <Option value="1">已排课</Option>
                <Option value="0">未排课</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="课程类型" prop="tchChannel">
              <Select v-model.number="queryParam.tchChannel" placeholder="全部" clearable
                      @on-change="search">
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>

        </Row>


      </Form>

      <div class="button-container">

        <Button class="left-button" type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">
          搜索
        </Button>

        <div class="spacer"></div>

        <Row>
                   <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search" @click="exportData">
            导出
          </Button>
          <Button type="primary" @click="onAssignAdviser">分配课程顾问</Button>
          <Button type="primary" @click="onAssignStudyAdviser">分配学导</Button>
          <Button type="primary" @click="salesServerAlone">销售独立服务</Button>
          <Button type="primary" icon="" @click="cannelStudy">取消学导绑定</Button>
          <Button type="primary" @click="onBatchCompletedCourses">批量结课</Button>
          <Button type="primary" @click="showStopLessonModel">移至停课</Button>
          <Button type="primary" @click="showToRefundModal">移至退费</Button>
        </Row>

      </div>

    </div>


    <List

      ref="dataList"
      :tableColumns="title"
      :reload="reload"
      listUrl="/user/pay/provisional"
      class="pay-list"
      :params="queryParam"
      :onLoading="onLoading"
      operator=""
      @on-selection-change="selectionChange"
    ></List>

    <AssignAdviserModal
      :successCallback="search"
      :userList="selectionUser"
      v-model="showAssignAdviserModal"
    ></AssignAdviserModal>
    <AssignUserStudyModal
      :successCallback="search"
      :userList="selectionUser"
      v-model="showAssignUserStudyAdviserModal"
      @on-close="onStudyAdviserClose"
    ></AssignUserStudyModal>
    <UserTestNetworkModal
      :user="testNetworkParam"
      v-model="showTestNetworkModal"
    >
    </UserTestNetworkModal>
    <UserLeaveModal
      v-model="showUserLeaveModal"
      :uid="uid"
      @on-close="closeModal"
      :successCallback="search"
    ></UserLeaveModal>
    <UserTempLessonModal
      :user="tempLessonUser"
      v-model="showUserTempLessonModal"
    ></UserTempLessonModal>
    <UserChineseLessonModal
      :user="chineseLessonUser"
      v-model="showUserChineseLessonModal"
    ></UserChineseLessonModal>
    <UserPLLessonModal
      :user="pLLessonUser"
      v-model="showUserPLLessonModal"
    ></UserPLLessonModal>


    <UserClassHourModal
      :uid="uid"
      v-model="showUserClassHourModal"
    ></UserClassHourModal>
    <UserLeaveNumModal
      :uid="uid"
      v-model="showUserLeaveNumModal"
    ></UserLeaveNumModal>
    <UserLessonNumModal
      :uid="uid"
      v-model="showUserLessonNumModal"
    ></UserLessonNumModal>
    <CourseSchedulingModal
      :uid="uid"
      v-model="showCourseSchedulingModal"
      @on-close="closeModal"
    ></CourseSchedulingModal>
    <BindTchModal
      :user="currentRow"
      :successCallback="search"
      v-model="showBindTchModal"
    ></BindTchModal>
    <UpdateLevelModal
      :user="currentRow"
      :successCallback="search"
      v-model="showUpdateLevelModal"
    ></UpdateLevelModal>
    <UserInfoModal
      :value="editUser"
      @on-close="closeModal"
      :uid="uid"
      :successCallback="search"
    ></UserInfoModal>
    <reject-wo-modal
      :successCallback="search"
      :studentId="uid"
      @on-close="closeModal"
      v-model="rejectWoModal"
    ></reject-wo-modal>
    <UserActivityNumModal
      :uid="uid"
      v-model="showActivityNumModal"
      :successCallback="search"
    ></UserActivityNumModal>
    <BookExchangeModal :uid="uid" v-model="showBookExchangeModal"/>
    <StudentClassHourModal :uid="uid" v-model="showStudentClassHourModal"/>
    <ToRefundModal v-model="showRefundModal" :uid="refundUid" :successCallback="search"></ToRefundModal>
    <BatchCompletedCoursesModal :uidStr="uidStr" :successCallback="search"
                                v-model="showBatchCompletedCoursesModal"></BatchCompletedCoursesModal>
    <Modal title="请填写停课理由" v-model="showStudentLeaveModal">
      <Form class="form" ref="showStudentLeave" :model="showStudentLeaveForm" :rules="showStudentLeaveRule">
        <Row>
          <Col :span="20">
            <Form-item label="复课时间" prop='startStudyDate'>
              <DatePicker type="date" :options="options" placeholder="选择时间" style="width: 200px"
                          @on-change="startStudyDate"></DatePicker>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="20">
            <Form-item label="停课原因" prop='leaveResult'>
              <Input v-model="showStudentLeaveForm.leaveResult" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                     placeholder="请输入停课理由"/>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showStudentLeaveModal = false">取消</Button>
        <Button type="primary" size="large" :loading="loadingShowStudentLeave" @click="inStopLesson">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import AssignAdviserModal from './AssignAdviserModal.vue'
import AssignUserStudyModal from './modal/AssignUserStudyModal.vue'
import UserTestNetworkModal from './modal/UserTestNetworkModal.vue'
import UserLeaveModal from './UserLeaveModal.vue'
import UserTempLessonModal from './modal/UserTempLessonModal.vue'
import UserChineseLessonModal from './UserChineseLessonModal.vue'
import UserPLLessonModal from './UserPLLessonModal.vue'
import UserClassHourModal from './UserClassHourModal.vue'
import UserLeaveNumModal from './UserLeaveNumModal.vue'
import UserLessonNumModal from './UserLessonNumModal.vue'
import CourseSchedulingModal from './modal/CourseSchedulingModal.vue'
import UserInfoModal from '../crm/UserInfoModal.vue'
import BindTchModal from './modal/BindTchModal.vue'
import RejectWoModal from './modal/RejectWoModal.vue'
import UserActivityNumModal from './UserActivityNumModal.vue'
import dates from '@/tools/date/dates.js'
import BookExchangeModal from './BookExchangeModal.vue'
import UpdateLevelModal from './modal/UpdateLevelModal.vue'
import StudentClassHourModal from './modal/StudentClassHourModal.vue'
import BatchCompletedCoursesModal from './BatchCompletedCoursesModal.vue'
import ToRefundModal from './modal/ToRefundModal.vue'

export default {
  components: {
    BatchCompletedCoursesModal,
    UpdateLevelModal,
    BookExchangeModal,
    AssignAdviserModal,
    AssignUserStudyModal,
    UserTestNetworkModal,
    UserLeaveModal,
    UserTempLessonModal,
    UserChineseLessonModal,
    UserPLLessonModal,
    UserClassHourModal,
    UserLeaveNumModal,
    CourseSchedulingModal,
    BindTchModal,
    UserInfoModal,
    UserLessonNumModal,
    UserActivityNumModal,
    RejectWoModal,
    StudentClassHourModal,
    ToRefundModal
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      loadingShowStudentLeave: false,
      exportLoading: false,
      reload: 0,

      editUser: false,
      showStudentClassHourModal: false,
      showRefundModal: false,
      refundUid: '',
      showBatchCompletedCoursesModal: false,
      showStudentLeaveModal: false,
      showStudentLeaveForm: {
        startStudyDate: '',
        leaveResult: ''
      },
      options: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      showStudentLeaveRule: {
        startStudyDate: [
          {type: 'string', required: true, message: '请选择时间', trigger: 'blur'}
        ],
        leaveResult: [
          {type: 'string', required: true, message: '请输入停课原因', trigger: 'blur'}
        ]
      },
      dateRange: [],
      queryParam: {
        startTime: '',
        endTime: '',
        isStudyAdviser: '',
        isTch: '',
        tchBoundNum: null,
        isNextWeekLessonOpened: '',
        status: null,
        searchKeyword: '',
        studyAdviserName: '',
        serviceAttribution: '',
        studyAdviserMobile: '',
        materialVersionId: '',
        bookMaterialLevelId: '',
        bindLessonNum: '',
        age: null,
        lessonWeek: '',
        lessonId: '',
        lessonNum: '',
        lastLessonNum: '',
        adminUserId: '',
        adviserId: '',
        woStatus: '',
        woVersion: null
      },
      lessonWeek: [],
      uid: null,
      uidStr: '',
      currentRow: null,
      showAssignAdviserModal: false,
      showAssignUserStudyAdviserModal: false,
      selectionUser: [],
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModal: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showBookExchangeModal: false,
      showCourseSchedulingModal: false,
      showActivityNumModal: false,
      showBindTchModal: false,
      showUpdateLevelModal: false,
      rejectWoModal: false,
      testNetworkParam: {},
      title: [
        {
          type: 'selection',
          width: 40,
          fixed: 'left',
          align: 'center'
        },
        {
          title: 'ID',
          key: 'id',
          fixed: 'left',
          align: 'center',
          width: 100
        },
        {
          title: '中 (英) 文名',
          width: 140,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let age = row.age
            if (age) {
              age = age + '岁'
            }
            let content = [
              h('Tooltip', {
                props: {
                  content: row.remark || '',
                  placement: 'right',
                  disabled: !row.remark,
                  transfer: true
                }
              }, [
                h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.nickname)
              ]),
              h('p', row.enName)
            ]
            content.push(h('p', age))
            if (row.fullGiftRemain > 0) {
              content.push(h('p', {style: {color: 'red', 'font-size': '12px'}}, '畅学满赠剩余' + row.fullGiftRemain + '次'))
            }
            return h('div', content)
          }
        },
        {
          title: '手机号',
          align: 'center',
          width: 130,
          key: 'mobile',
          render: (h, params) => {
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '课程顾问',
          width: 90,
          align: 'center',
          key: 'adviserName',
          render: (h, params) => {
            return h('span', params.row.adviserName || '未分配')
          }
        },
        {
          title: '学导',
          width: 90,
          align: 'center',
          key: 'studyAdviserName',
          render: (h, params) => {
            return h('span', params.row.studyAdviserName || '未分配')
          }
        },
        {
          title: '学生服务归属',
          width: 150,
          align: 'center',
          key: 'serviceAttribution',
          render: (h, params) => {
            return h('span', $constant.getEnum($constant.studentServerBy, params.row.serviceAttribution).text)
          }
        },
        {
          title: '绑定老师',
          width: 220,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchBoundNum && row.tchBoundNum > 0) {
              let list = row.bookWorkLessonOpenedTimeList
              let spanArr = []
              if (list) {
                list.forEach(function (element) {
                  let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
                  spanArr.push(h('span', [
                    h('span', element.tchId + '-' + element.tchName),
                    h('span', '[' + $constant.weekZh[element.week] + startTime + ']')]))
                  spanArr.push(h('br'))
                })
              }
              let levelTitle = row.levelTitle
              if (levelTitle) {
                levelTitle = '当前等级：' + levelTitle
              }
              return h('div', {style: {'font-size': '12px'}}, [h('p', levelTitle), h('p', spanArr)])
            } else {
              return h('div', '未绑定')
            }
          }
        },
        {
          title: '等级',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.levelTitle || '未分级')
          }
        },
        {
          title: '订单列表',
          width: 320,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let list = row.fundPackageDtoList
            let spanArr = []
            if (list) {
              list.forEach(function (e) {
                let state = e.state
                let stateStr = ''
                if (state) {
                  if (state === 4) {
                    stateStr = '部分支付'
                  } else if (state === 5) {
                    stateStr = '全部支付'
                  } else if (state === 1) {
                    stateStr = '支付成功'
                  } else if (state === 6) {
                    stateStr = '财务审核'
                  }
                } else {
                  if (state === 0) {
                    stateStr = '待支付'
                  }
                }
                let channel = ''
                if (e.channel) {
                  let channelEnum = $constant.getEnum($constant.orderChannel, e.channel)
                  channel = channelEnum && channelEnum.text
                }
                if (row.tchChannel === 1) {
                  spanArr.push(h('span', [
                    h('span', {style: {color: '#2d8cf0'}}, e.orderId + ':'),
                    h('span', channel + '外教课' + e.num + '节/直播课' + e.livingNum + '/中教课' + e.chineseNum + '节(' + e.amount + '元)->'),
                    h('span', {style: {color: 'red'}}, stateStr)]))
                }
                if (row.tchChannel === 2) {
                  spanArr.push(h('span', [
                    h('span', {style: {color: '#2d8cf0'}}, e.orderId + ':'),
                    h('span', '(' + e.amount + '元)->'),
                    h('span', {style: {color: 'red'}}, stateStr)]))
                }

                spanArr.push(h('br'))
              })
            }
            return h('div', {style: {'font-size': '13px'}}, spanArr)
          }
        },
        {
          title: '课时信息',
          width: 160,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchChannel === 2) {
              return h('a', {on: {click: () => this.showStudentClassHour(row)}}, '剩余课时：' + row.availableClassHour)
            }
            let leftRoutineNum = row.routineNum - row.routineEndNum
            leftRoutineNum = leftRoutineNum > 0 ? leftRoutineNum : 0
            let leftChineseNum = row.chineseNum - row.chineseEndNum
            leftChineseNum = leftChineseNum > 0 ? leftChineseNum : 0
            let leftPartNum = row.partnerNum - row.partnerEndNum
            leftPartNum = leftPartNum > 0 ? leftPartNum : 0
            return h('div', {style: {'font-size': '13px'}}, [h('p', '外教/中教/陪练'),
              h('p', '总课时:' + row.routineNum + ' / ' + row.chineseNum + ' / ' + row.partnerNum),
              h('p', '已完结:' + row.routineEndNum + ' / ' + row.chineseEndNum + ' / ' + row.partnerEndNum),
              h('p', {style: {color: 'red'}}, '剩余:' + leftRoutineNum + ' / ' + leftChineseNum + ' / ' + leftPartNum),
              h('p', {style: {color: 'green'}}, '锁定:' + row.waitEngNum + ' / ' + row.waitChineseNum + ' / ' + row.waitPartnerNum)
            ])
          }
        },
        {
          title: '请假统计',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let leaveNum = row.leaveNum
            leaveNum = leaveNum > 0 ? leaveNum : 0
            let leftMakeUpLessonNum = row.makeupLessonNum - row.makeupLessonEndNum
            leftMakeUpLessonNum = leftMakeUpLessonNum > 0 ? leftMakeUpLessonNum : 0
            return h('div', [h('p', '请假次数:' + leaveNum), h('p', '补课次数:' + leftMakeUpLessonNum)])
          }
        },
        {
          title: '工单类型',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let woVersion = row.woVersion
            let woVersionStr = ''
            if (woVersion >= 0) {
              let woVersionEnum = $constant.getEnum($constant.woVersion, woVersion)
              woVersionStr = woVersionEnum && woVersionEnum.text
            }
            return h('span', woVersionStr)
          }
        },
        {
          title: '工单状态',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let status = row.woStatus
            let woStatus = ''
            if (status) {
              let statusEnum = $constant.getEnum($constant.woStatus, status)
              woStatus = statusEnum && statusEnum.text
            }
            return h('span', woStatus)
          }
        },
        {
          title: '开课时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('span', row.classOpeningTime)
          }
        },
        {
          title: '工单提交时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('span', row.woSubmitTime)
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 70,
          render: (h, params) => {
            let row = params.row
            let id = row.id
            // let userTrackListQueryParam = {
            //   uid: id
            // }
            let status = row.woStatus
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'testNetwork'}}, '约测网课'))
            btn.push(h('Dropdown-item', {props: {name: 'courseScheduling'}}, '固定排课'))
            btn.push(h('Dropdown-item', {props: {name: 'userTemp'}}, '临时约课'))
            if (status === 'UNAUDITED') {
              btn.push(h('Dropdown-item', {props: {name: 'woApprove'}}, '审批工单'))
              btn.push(h('Dropdown-item', {props: {name: 'woInProgress'}}, '处理中'))
              btn.push(h('Dropdown-item', {props: {name: 'woReject'}}, '驳回工单'))
            }

            btn.push(h('Dropdown-item', {props: {name: 'PracticePartnerLesson'}}, '约陪练课'))
            btn.push(h('Dropdown-item', {props: {name: 'chineseLesson'}}, '约中教课'))
            btn.push(h('Dropdown-item', {props: {name: 'userLeave'}}, '学生请假'))
            let bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList
            if (!bookWorkLessonOpenedTimeList) {
              btn.push(h('Dropdown-item', {props: {name: 'bindTch'}}, '绑定老师'))
            } else {
              btn.push(h('Dropdown-item', {props: {name: 'editBindTch'}}, '修改绑定'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'updateLevel'}}, '学员定级'))
            btn.push(h('Dropdown-item', {props: {name: 'changeDirector'}}, '学员转移'))
            btn.push(h('Dropdown-item', {props: {name: 'classHour'}}, '加减课时'))
            btn.push(h('Dropdown-item', {props: {name: 'leaveNum'}}, '加减请假次数'))
            btn.push(h('Dropdown-item', {props: {name: 'lessonNum'}}, '加减补课次数'))
            btn.push(h('Dropdown-item', {props: {name: 'track'}}, '跟踪记录'))
            btn.push(h('Dropdown-item', {props: {name: 'activity'}}, '积分兑换'))
            btn.push(h('Dropdown-item', {props: {name: 'book'}}, '绘本兑换'))
            return h('div', [
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    if (name === 'testNetwork') {
                      this.showTestNetworkModal = true
                      this.testNetworkParam = row
                      this.testNetworkParam.uid = row.id
                    } else if (name === 'userTemp') {
                      this.showUserTempLessonModal = true
                      this.tempLessonUser = row
                    } else if (name === 'userLeave') {
                      this.uid = id
                      this.showUserLeaveModal = true
                    } else if (name === 'PracticePartnerLesson') {
                      this.pLLessonUser = row
                      this.showUserPLLessonModal = true
                    } else if (name === 'chineseLesson') {
                      this.chineseLessonUser = row
                      this.showUserChineseLessonModal = true
                    } else if (name === 'bindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                    } else if (name === 'editBindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                    } else if (name === 'updateLevel') {
                      this.currentRow = row
                      this.showUpdateLevelModal = true
                    } else if (name === 'classHour') {
                      this.uid = id
                      this.showUserClassHourModal = true
                    } else if (name === 'changeDirector') {
                      this.uid = id
                      this.onChangeDirector(row)
                    } else if (name === 'leaveNum') {
                      this.uid = id
                      this.showUserLeaveNumModal = true
                    } else if (name === 'lessonNum') {
                      this.uid = id
                      this.showUserLessonNumModal = true
                    } else if (name === 'courseScheduling') {
                      this.uid = id
                      this.showCourseSchedulingModal = true
                    } else if (name === 'track') {
                      this.$router.push({path: '/user/userTrackList', query: this.userTrackListQueryParam})
                    } else if (name === 'activity') {
                      this.uid = id
                      this.showActivityNumModal = true
                    } else if (name === 'woApprove') {
                      this.woApprove(id)
                    } else if (name === 'woReject') {
                      this.woReject(row)
                    } else if (name === 'woInProgress') {
                      this.woInProgress(id)
                    } else if (name === 'book') {
                      this.uid = id
                      this.showBookExchangeModal = true
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ]),
            ])
          }
        }
      ],
      bookMaterialLevelList: [],
      lessonAll: []
    }
  },
  mounted: function () {
    let query = this.$route.query
    if (query) {
      if (query.lessonWeek) {
        let lessonWeekArr = query.lessonWeek.split(',')
        for (let i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i])
        }
      }
    }
  },
  created: function () {
    let query = this.$route.query
    if (query) {
      if (query.lessonWeek) {
        let lessonWeekArr = query.lessonWeek.split(',')
        for (let i in lessonWeekArr) {
          this.lessonWeek[i] = parseInt(lessonWeekArr[i])
        }
      }
    }
  },
  methods: {
    // 已试听
    inStopLesson () {
      let self = this
      this.stopLoading = true
      if (self.showStudentLeaveForm.startStudyDate == '' || self.showStudentLeaveForm.leaveResult == '') {
        this.$Message.warning('请填写停课信息')
        return
      }
      this.$http.post('/user/lessonsStop/inUserStopLesson', {
        ids: self.uidStr,
        resumeClassDate: this.showStudentLeaveForm.startStudyDate,
        remark: this.showStudentLeaveForm.leaveResult
      }).then((res) => {
        if (res && res.data > 0) {
          self.$Message.success('移至停课，申请审核成功！')
          self.stopLoading = false
          self.showStudentLeaveModal = false
          self.search()
        } else {
          self.$Message.error(res.msg)
          self.stopLoading = false
          self.showStudentLeaveModal = false
        }
      }).catch((e) => {
        this.stopLoading = false
        self.$Message.error(e)
      })
    },
    startStudyDate (value) {
      console.log(`value`, value)
      if (value === '') {
        this.$Message.warning('请输入复课时间')
      }
      this.showStudentLeaveForm.startStudyDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    onDateChange (dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.queryParam.startTime = this.$moment(dateRange[0], 'YYYY-M-D H:m').format('X')
        this.queryParam.endTime = this.$moment(dateRange[1], 'YYYY-M-D H:m').format('X')
      } else {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    startTimeDateChange (value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange (value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserProvisionalList'}
      })
      window.open(href, '_blank')
    },
    onStudyAdviserClose () {
      this.showAssignUserStudyAdviserModal = false
    },
    search () {
      let self = this
      if (this.dateRange.length == 2) {
        if (this.dateRange[0]) {
          let startTimeDate = dates.format(this.dateRange[0])
          self.queryParam.startTime = Date.parse(startTimeDate) / 1000
        } else {
          self.queryParam.startTime = ''
        }
        if (this.dateRange[1]) {
          self.queryParam.endTime = this.$moment(this.dateRange[1], 'YYYY-M-D H:m').format('X')
        } else {
          self.queryParam.endTime = ''
        }
      } else {
        self.queryParam.startTime = ''
        self.queryParam.endTime = ''
      }

      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    searchList () {
      this.reload = new Date().getTime()
    },
        onLoading (loading) {
      this.searchLoading = loading
    },
    selectionChange (selection) {
      this.selectionUser = selection
    },
    exportData () {
      this.exportLoading = true
      this.$http.get('/user/pay/provisional-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '待分配学生.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onAssignAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！')
        return
      }
      this.showAssignAdviserModal = true
    },
    onAssignStudyAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！')
        return
      }
      this.showAssignUserStudyAdviserModal = true
    },
    salesServerAlone () {
      let self = this
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要销售独立服务的学生！')
        return
      }
      let idList = self.selectionUser.map(function (element) {
        return element.id
      })
      let params = {ids: idList.join(',')}
      self.$http.get('/user/lessonsStop/batchUpdateServiceAttribution', {params: params}).then(function (res) {
        if (res.status == 'ok') {
          self.$Message.success('学生已转变为销售独立服务')
          self.search()
        }
      }).catch(function (e) {
        self.$Message.error('系统异常')
      })
    },
    onChangeDirector (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search()
            self.$Message.success('转移成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    selectWeek () {
      this.queryParam.lessonWeek = []
      this.queryParam.lessonWeek = this.lessonWeek.join(',')
    },
    loadLevelIds (val) {
      let self = this
      let url = '/bookMaterialLevel/listByCondition'
      if (val) {
        url = '/bookMaterialLevel/listByCondition?materialVersion=' + val
      }
      self.$http.get(url).then(res => {
        if (res && res.data) {
          self.bookMaterialLevelList = res.data
        }
      })
    },
    woApprove (id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>审批</b>工单？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          let data = {studentId: id}
          self.$http.post('/sale/wo/approve', data).then(res => {
            if (res) {
              self.search()
              self.$Message.success('审核成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    woInProgress (id) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否<b>处理</b>工单？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$Modal.remove()
          let data = {studentId: id}
          self.$http.post('/sale/wo/inProgress', data).then(res => {
            if (res) {
              self.search()
              self.$Message.success('操作成功!')
            }
            self.$Modal.remove()
          })
        }
      })
    },
    woReject (row) {
      this.uid = row.id
      this.rejectWoModal = true
    },
    changeLevel (val) {
      let self = this
      if (val) {
        self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
          if (res && res.data) {
            self.lessonAll = res.data
          }
        })
      }
    },
    cannelStudy () {
      let self = this
      let idList = self.selectionUser.map(function (element) {
        return element.id
      })
      self.loadingAssignAdviser = true
      let params = {ids: idList.join(','), studyAdviserId: 0, reason: ''}
      self.$http.get('/user/updateStudyAdviser', {params: params}).then(function (res) {
        if (res) {
          self.$Message.success('成功！')
          self.loadingAssignAdviser = false
          self.search()
        }
      }).catch(function (e) {
        self.$Message.error('失败！')
        self.loadingAssignAdviser = false
      })
    },
    onBatchCompletedCourses () {
      let self = this
      if (self.selectionUser.length <= 0) {
        self.$Message.warning('请选择需学生！')
        return
      }
      let idList = self.selectionUser.map(function (element) {
        return element.id
      })
      self.uidStr = idList.join(';')
      self.showBatchCompletedCoursesModal = true
    },
    showStopLessonModel () {
      let self = this
      let ids = []
      if (this.selectionUser && this.selectionUser.length > 0) {
        for (let i in this.selectionUser) {
          let dto = this.selectionUser[i]
          ids[i] = dto.id
        }
      } else {
        this.$Message.warning('请选择停课目标')
        return
      }
      self.uidStr = ids.join(',')
      self.showStudentLeaveModal = true
    },
    showToRefundModal () {
      if (!this.selectionUser || this.selectionUser.length !== 1) {
        this.$Message.warning('请勾选恰好1名学生')
        return
      }
      this.refundUid = this.selectionUser[0].id
      this.showRefundModal = true
    },
    showStudentClassHour (row) {
      this.uid = row.id
      this.showStudentClassHourModal = true
    }
  }
}

</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 20px;
}

.button-container {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// UserProvisionalList.vue?76f857d0